import React from "react";
import Form from "theme/components/atoms/Form/Form";
import GroupedItemLine from "./GroupedItemLine";

export const hasGroupedItems = (product) => product.groupedItems?.length > 0;

const GroupedItems = ({ product, selectedGroupedItems, setGroupedItems }) => {
  if (!hasGroupedItems(product)) {
    return null;
  }
  return (
    <Form
      onChange={(data) => {
        setGroupedItems(data.items);
      }}
    >
      <div className="grouped-items">
        {product.groupedItems.map((item, index) => {
          const prefix = `items[${index}]`;
          const selectedGroupedItem = selectedGroupedItems.find(
            ({ sku }) => sku === item.product.sku
          );
          return (
            <div key={item.product.sku} className="grouped-items__item">
              <GroupedItemLine
                prefix={prefix}
                item={item}
                qty={selectedGroupedItem?.qty ?? item.qty}
              />
            </div>
          );
        })}
      </div>
    </Form>
  );
};

export default GroupedItems;
